export default __webpack_public_path__ + "static/media/instagram.90a80cd5.svg";